// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProBadge":"beg_a bhn_rj bhn_rk bhn_vh bhn_eb bhn_vf bhn_gu bhn_kh"};